import React from 'react'
import { Briefcase } from 'lucide-react'
import type { JobApplicationProps } from '@/features/enrollment'

export default function JobApplication({ showJobApplication, applyForJob }: JobApplicationProps) {
  return (
    <div className="border border-purple-200 rounded-lg p-4 lg:p-6">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between mb-4 gap-4">
        <div>
          <h4 className="font-semibold text-purple-900">Become a Sales Agent</h4>
          <p className="text-sm text-purple-600">Interested in joining our team? Apply to become a sales agent!</p>
        </div>
        <button
          onClick={applyForJob}
          className="bg-purple-600 hover:bg-purple-700 text-white px-4 py-2 rounded-lg font-medium transition-colors flex items-center space-x-2"
        >
          <Briefcase className="w-4 h-4" />
          <span>Apply Now</span>
        </button>
      </div>
      
      {showJobApplication && (
        <div className="bg-purple-50 border border-purple-200 rounded p-4 space-y-3">
          <h5 className="font-medium text-purple-900 mb-3">Job Application</h5>
          <p className="text-sm text-purple-700">
            Thank you for your interest! Our HR team will review your application and contact you soon.
            You'll be automatically attached to your original sales agent as their new employee.
          </p>
          <div className="bg-purple-100 border border-purple-300 rounded p-3">
            <p className="text-xs text-purple-800">
              <strong>Benefits:</strong> Commission-based earnings, flexible hours, training provided, 
              opportunity to help others while earning income.
            </p>
          </div>
        </div>
      )}
    </div>
  )
}
